import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    class: "c-card-content__item",
    name: "meals"
};
const _hoisted_2 = { class: "d-sm-flex justify-content-between mb-4" };
const _hoisted_3 = { class: "form-label h6 mb-0" };
const _hoisted_4 = {
    key: 0,
    class: "small text-danger"
};
const _hoisted_5 = { class: "c-select-item row" };
const _hoisted_6 = { class: "col-lg-5" };
const _hoisted_7 = {
    key: 0,
    class: "text-danger ms-1"
};
const _hoisted_8 = { class: "col-lg-7" };
import { DepositType } from '@js/types/enum/deposit-type';
import { MealType } from '@js/types/enum/meal-type';
import SelectField from '@vue/components/form/SelectField.vue';
import ValidateState from '@vue/components/form/ValidateState.vue';
import { $lang } from '@vue/services/utilities';
import { useField } from 'vee-validate';
import { computed, inject, ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MealsField',
    props: {
        type: {},
        meals: {},
        min: {},
        max: {},
        depositType: {},
        title: {}
    },
    emits: ['update'],
    setup(__props, { emit: __emit }) {
        const emits = __emit;
        const locale = inject('locale');
        const props = __props;
        const filedName = props.type === MealType.MAIN ? 'meals' : 'additionalMeals';
        const requireMainMeals = computed(() => {
            return props.type === MealType.MAIN
                && (props.meals?.length ?? 0) > 0;
            //&& props.depositType !== DepositType.HEAD; // ✅ MEAL + 不收訂金 都必填
            //拿掉 只要有餐點的就要必填
        });
        const field = useField(() => filedName, computed(() => requireMainMeals.value ? `minMeals:${props.min}` : ''));
        /*const field = useField(() => filedName, computed(() => {
          if (props.depositType === DepositType.MEAL && props.type === MealType.MAIN) {
            return 'minMeals:' + props.min;
          }
        
        
          return '';
        }));*/
        const selected = ref([]);
        const validateInputClass = ref();
        const validateTooltipClass = ref();
        /*watch(() => selected.value, (v) => {
          const sum = v.reduce((sum, item) => sum + item.quantity, 0);
          field.setValue(sum);
        
          emits('update', v);
        }, {
          deep: true
        });*/
        watch(() => selected.value, (v) => {
            const sum = v.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
            field.setValue(sum);
            emits('update', v);
        }, { deep: true });
        function changeValidateState(v) {
            validateInputClass.value = v.inputClass;
            validateTooltipClass.value = v.tooltipClass;
        }
        function getMealTitle(meal) {
            return locale === 'zh-TW' ? meal.tw.title : meal.en.title;
        }
        function getMealRemark(meal) {
            return locale === 'zh-TW'
                ? meal.tw?.remark
                : meal.en?.remark;
        }
        const maxMealOptions = computed(() => {
            let length = props.max;
            let currentQuantity = 0;
            if (!selected.value.length) {
                return length;
            }
            selected.value.forEach((v) => {
                //currentQuantity = currentQuantity + v.quantity;
                currentQuantity = currentQuantity + Number(v.quantity || 0);
            });
            return length - currentQuantity;
        });
        function prepareMealOptions(id) {
            let options = [];
            options.push({
                text: 0 + $lang('app.reservation.label.meal.unit'),
                value: 0
            });
            let length = maxMealOptions.value + Number(selected.value.find(item => item.id === id)?.quantity ?? 0);
            if (props.type === MealType.ADDITIONAL) {
                length = 20;
            }
            for (let i = 1; i <= length; i++) {
                options.push({
                    text: i + $lang('app.reservation.label.meal.unit'),
                    value: i
                });
            }
            return options;
        }
        function setMealData(id, q) {
            const quantity = parseInt(q);
            if (!selected.value.length) {
                selected.value.push({ id, quantity });
                return;
            }
            selected.value = selected.value.filter(v => v.id !== id);
            if (quantity) {
                selected.value.push({ id, quantity });
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("label", _hoisted_3, [
                        _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
                        (requireMainMeals.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "*"))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", null, [
                        _createElementVNode("div", {
                            class: _normalizeClass(validateInputClass.value)
                        }, null, 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(["position-relative top-0", validateTooltipClass.value])
                        }, _toDisplayString(_unref(field).errorMessage), 3)
                    ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meals, (meal) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("span", null, _toDisplayString(getMealTitle(meal)), 1),
                            ((_unref(locale) === 'zh-TW' ? meal.tw?.remark : meal.en?.remark))
                                ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_unref(locale) === 'zh-TW' ? meal.tw?.remark : meal.en?.remark), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createVNode(SelectField, {
                                name: `meal-` + meal.id,
                                class: "c-select-item__select",
                                "default-value": 0,
                                options: prepareMealOptions(meal.id),
                                sort: true,
                                onUpdate: ($event) => (setMealData(meal.id, $event))
                            }, null, 8, ["name", "options", "onUpdate"])
                        ])
                    ]));
                }), 256)),
                _createVNode(ValidateState, {
                    field: _unref(field),
                    onValidateState: changeValidateState
                }, null, 8, ["field"])
            ]));
        };
    }
});
